import script from "./Goods.vue?vue&type=script&lang=ts&setup=true"
export * from "./Goods.vue?vue&type=script&lang=ts&setup=true"

import "./Goods.vue?vue&type=style&index=0&id=6589d17c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6589d17c"]])

export default __exports__